import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100" style={{ backgroundColor: "#F9F9F9" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Land in the Mobile Market with Most In-Demand Functionalities
            </h2>
            <p>
              We have a team of 40+ iOS experts including UI/UX designers, core
              developers, performance testers, business analysts, and product
              growth technologists. Combined with novel technologies and
              Apple-influenced trends we help startups, scaleups, and
              enterprises get a solution that functions best, engages users, and
              grows with you.
            </p>
          </Col>
        </Row>
        <Row className="h-100 perks-padd">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content ">
                <h4>Cloud-Based Hybrid Infrastructure</h4>
                <p>
                  Leverage cloud tech for seamless data storage, app deployment,
                  and collaboration for adaptability and scalability.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  AI & <br />
                  ML
                </h4>
                <p>
                  Integrate AI/ML for personalized experiences, predictive
                  analytics, and efficient decision-making, improving engagement
                  and insights.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  5G & <br />
                  IoT
                </h4>
                <p>
                  Use 5G and IoT for faster data, lower latency, and advanced
                  features like AR/VR and smart automation.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Robotic Process <br />
                  Automation
                </h4>
                <p>
                  Implement RPA to automate tasks, boosting productivity and
                  allowing focus on strategic growth initiatives.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Perks;
